/**
 * Starts a worker that suggests field boundaries off the main thread, or
 * returns `null` where workers are unavailable or cannot start.
 *
 * @remarks
 * Kept in a module of its own because Jest cannot parse `import.meta`; the
 * Jest config maps this module to `create-worker.stub.ts`.
 */
export function createFieldBoundaryWorker(): Worker | null {
  if (typeof Worker === 'undefined') {
    return null;
  }
  try {
    return new Worker(
      new URL('./field-boundary-suggestion.worker', import.meta.url),
    );
  } catch {
    return null;
  }
}
